import { EmptyState, Icons } from "@dms/ui";

// 12-screen-spec §14 (403).
export function ForbiddenPage() {
  return (
    <div role="alert" style={{ paddingTop: 40 }}>
      <EmptyState
        icon={<Icons.lock size={26} />}
        title="У вас немає доступу до цього розділу"
        description="Якщо вважаєте це помилкою — зверніться до системного адміністратора."
      />
    </div>
  );
}
